/**
 * This method can be used to mimic debounce behaviour.
 *
 * @param func
 * @param wait
 * @returns {executedFunction}
 */

const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            timeout = null;
            func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

export default debounce;